import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 25, mass: 0.3 });
    return (
        <motion.div
            aria-hidden
            style={{ scaleX, transformOrigin: "0% 50%" }}
            className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-emerald-400 via-emerald-500 to-blue-500 z-[60] origin-left"
        />
    );
}
